import { Grid } from '@mui/material';
import { IMAGE_HEIGHT } from '../media-item';
import { getImageBySize } from 'utils/helpers';
import PlayIcon from 'assets/icons/play-icon.svg';

interface MediaVideoItemProps {
  thumbnailUrl?: string;
  onClick?: () => void;
  width: number;
}

export const MediaVideoItem = ({ thumbnailUrl, onClick, width }: MediaVideoItemProps) => {
  const itemWidth = (width - 8) / 3;
  const previewUrl = thumbnailUrl
    ? getImageBySize(thumbnailUrl, itemWidth, IMAGE_HEIGHT, false)
    : undefined;
  const isValidUrl = previewUrl && (previewUrl.startsWith('http://') || previewUrl.startsWith('https://') || previewUrl.startsWith('data:'));

  return (
    <Grid
      onClick={onClick}
      sx={{
        width: 'calc((100% - 8px) / 3)',
        height: `${IMAGE_HEIGHT}px`,
        position: 'relative',
        borderRadius: '12px',
        overflow: 'hidden',
        cursor: 'pointer',
        backgroundColor: isValidUrl ? 'transparent' : '#1a1a1a',
        ...(isValidUrl && {
          background: `url(${previewUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        sx={{
          width: 50,
          height: 50,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <PlayIcon />
      </Grid>
    </Grid>
  );
};
